var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReddit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#ec4624}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67,35.5c0-3.7-3-6.7-6.7-6.7c-1.8,0-3.4,0.7-4.6,1.8c-4-3.2-9.4-5.2-15.5-5.7l3.4-10.3l8.6,4.3 c0,0.2,0,0.3,0,0.5c0,2.2,1.8,4,4,4c2.2,0,4-1.8,4-4c0-2.2-1.8-4-4-4c-1.1,0-2.1,0.4-2.8,1.1l-8.7-4.4c-0.7-0.3-1.4-0.4-2.1-0.1 c-0.7,0.3-1.2,0.8-1.5,1.6l-3.7,11.1c-7.1,0-13.5,2.3-18.1,5.8c-1.2-1.1-2.8-1.8-4.6-1.8c-3.7,0-6.7,3-6.7,6.7 c0,2.8,1.8,5.3,4.2,6.2c-0.1,0.8-0.2,1.6-0.2,2.5c0,10.7,11.4,19.4,25.5,19.4c14.1,0,25.5-8.7,25.5-19.4c0-0.8-0.1-1.7-0.2-2.5 C65.2,40.7,67,38.3,67,35.5z M24.1,40.8c0-2.2,1.8-4,4-4s4,1.8,4,4c0,2.2-1.8,4-4,4S24.1,43.1,24.1,40.8z M48,52.3 c-0.1,0.2-3.2,4.6-10.5,4.6c-7.3,0-10.4-4.4-10.5-4.6c-0.4-0.6-0.3-1.4,0.4-1.9c0.6-0.4,1.4-0.2,1.9,0.4c0.1,0.1,2.4,3.4,8.3,3.4 s8.2-3.3,8.3-3.4c0.4-0.6,1.2-0.8,1.9-0.3C48.2,50.9,48.4,51.7,48,52.3z M46.9,44.9c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4 c2.2,0,4,1.8,4,4C50.9,43.1,49.1,44.9,46.9,44.9z",
    className: "st0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.24308c3bce05eafd989ead85b321bb0d.svg";
export { ForwardRef as ReactComponent };